<template>
  <div class="sidebar-inner" style="width: 100%;">
    <el-row style="margin-bottom: 1.25rem;">
      <el-col :span="2">
        <span class="step-circle">1</span>
      </el-col>
      <el-col :span="22" class="v2__heading">Do you want to find all contacts who are or are not staff members?</el-col>
    </el-row>

    <el-row style="margin-bottom: 2rem;">
      <el-col :offset="2">
        <el-radio-group v-model="is_staff">
          <el-radio :label="true" border>Contacts who are staff members</el-radio>
          <el-radio :label="false" border>Contacts who are <b>not</b> staff members</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <el-form>
      <el-form-item>
        <el-button type="primary" class="xpl-button xpl-button--primary" @click.stop="commitCondition">Save this condition</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import EventBus from '@/event-bus';

  export default {
    props: ['condition', 'editedRule', 'enrollment', 'goalList'],
    data() {
      return {
        is_staff: true,
      };
    },
    created() {
      if (this.editedRule) {
        this.is_staff = this.editedRule.is_staff;
      }
    },
    methods: {
      commitCondition() {
        const payload = {
          condition: {
            uuid: this.condition.uuid,
            name: this.condition.name,
            unique: this.condition.unique,
          },
          is_staff: this.is_staff,
        };

        EventBus.$emit('conditions_selection.commit', payload);
      },
    },
  };
</script>
